import React from 'react';
import type { PlayerFollowerProps, PublicPlayerProps } from "../types";
import { Image, StyleSheet } from 'react-native';
import PlayerFollowButton from './PlayerFollowButton';
import { Button, Text, View } from '../Components/Themed';
import { useColors } from '../constants/useColors';

type PlayerCardProps = {
    player:PublicPlayerProps,
    width:number,
    follow_loading?:boolean,
    alignment?:'vertical'|'horizontal',
    player_follower?:PlayerFollowerProps,
    player_following?:PlayerFollowerProps,
    show_follow?:boolean,
    style?:any,
    onSelectPlayer?:(p:PublicPlayerProps) => void,
    onFollowingUpdate:(pf:PlayerFollowerProps) => void
}

const PlayerCard = ({ player, width, follow_loading, alignment, style, show_follow, player_follower, player_following, onSelectPlayer, onFollowingUpdate }:PlayerCardProps) => {
    const Colors = useColors();
    let player_style = alignment == 'vertical' ? local_styles.player_vertical : local_styles.player_horizontal;
    return (
        <View style={{ ...style, width:width, borderColor:Colors.borders.light, borderRadius:8 }}>
            <Button disabled={!onSelectPlayer} style={player_style} onPress={() => onSelectPlayer ? onSelectPlayer(player): console.log('')}>
                {alignment == 'vertical' ? 
                <View>
                    <Image
                        source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                        style={{ height:width * 0.5, width:width, borderTopRightRadius:8, borderTopLeftRadius:8 }}
                        resizeMode='cover'
                    />
                </View>
                :
                <View>
                    <Image
                        source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                        style={{ height:55, width:55, borderTopLeftRadius:8, borderBottomLeftRadius:8}}
                        resizeMode='cover'
                    />
                </View>
                }
                <View style={{ flexGrow:1, padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                    <Text size={14} theme='h1' textAlign={alignment == 'vertical' ? 'center' : 'left'}>{player.first_name} {player.last_name}</Text>
                    <Text style={{ marginTop:4 }} size={14} theme='description' textAlign={alignment == 'vertical' ? 'center' : 'left'}>@{player.username}</Text>
                </View>
                {show_follow ?
                <View style={{ padding:10, paddingTop:alignment=='vertical'?0:10, borderBottomLeftRadius:8, borderBottomRightRadius:8 }}>
                    <PlayerFollowButton
                        loading={follow_loading}
                        player_id={player.player_id}
                        follower={player_follower}
                        following={player_following}
                        onFollowingUpdate={onFollowingUpdate}
                    />
                </View>
                :<></>}
            </Button>
        </View>
    )
}

const local_styles = StyleSheet.create({
    player_vertical: {
        flex:1,
        flexDirection:'column',
        padding:0,
        borderTopRightRadius:8,
        borderTopLeftRadius: 8
        //alignItems:'center'
    },
    player_horizontal: {
        flex:1,
        flexDirection: 'row',
        alignItems:'center',
        padding:0
    }
})

export default PlayerCard